import React from 'react';

function DiagCpoRecallLoading() {
  return (
    <section className="section section_certification_inspect">
      <ul className="inspect_require_list">
        <li
          className="inspect_require_item skeleton"
          style={{height: 66, margin: '0px 0px 16px 0px'}}
        />
        <li
          className="inspect_require_item skeleton"
          style={{height: 66, margin: '16px 0px'}}
        />
        <li
          className="inspect_require_item skeleton"
          style={{height: 66, margin: '16px 0px'}}
        />
      </ul>
    </section>
  );
}

export default DiagCpoRecallLoading;
